import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Icon from '../components/Icon';
import { useLocale } from '../utils/locale';

export default function Programs() {
  const navigate = useNavigate();
  const { t } = useLocale();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/programs').then(setPrograms).finally(() => setLoading(false));
  }, []);

  async function handleDelete(id) {
    if (!window.confirm(t('Delete this program?'))) return;
    await api.delete('/programs/' + id);
    setPrograms(prev => prev.filter(p => p.id !== id));
  }

  return (
    <div>
      <div className="page-header">
        <h1>
          <Icon name="icon-program.png" />
          {t('Programs')}
        </h1>
        <button className="icon-btn" onClick={() => navigate('/programs/new')}>
          <Icon name="icon-add.png" alt="Add" />
        </button>
      </div>

      <div className="page-content">
        {loading ? (
          <div className="loading-spinner"><span className="spinner" /></div>
        ) : programs.length === 0 ? (
          <div className="empty-state">
            <Icon name="icon-program.png" size={48} style={{ opacity: 0.3 }} />
            {t('No programs yet')}
            <button className="btn btn-primary" style={{ width: 'auto', padding: '0 24px' }} onClick={() => navigate('/programs/new')}>{t('Create First Program')}</button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {programs.map(p => (
              <div key={p.id} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate('/programs/' + p.id)}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{p.name}</div>
                    {p.goal && <div style={{ fontSize: 13, color: 'var(--color-text-muted)', marginTop: 4 }}>{p.goal}</div>}
                    <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                      {p.duration_weeks && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{p.duration_weeks} weeks</span>}
                      {p.sessions_per_week && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{p.sessions_per_week}x / week</span>}
                    </div>
                  </div>
                  <button className="icon-btn" onClick={e => { e.stopPropagation(); handleDelete(p.id); }}>
                    <Icon name="icon-delete.png" alt="Delete" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
